import axios from 'axios';

export default axios.create({
  baseURL: 'https://react-quiz-47037-default-rtdb.firebaseio.com/',
});
